<template>
  <div>
    <v-toolbar class="stickyHeader" color="#444" elevation="4" dark>
      <v-toolbar-items>
        <v-btn icon dark @click="$emit('close')"> Ferdig </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>

      <v-btn icon @click="zoomOut">
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-toolbar-title class="white--text mx-2">
        {{ currentScaleDisplay }}
      </v-toolbar-title>
      <v-btn icon @click="zoomIn">
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <!-- <v-btn icon dark @click="save">
          <v-icon>mdi-content-save</v-icon>
        </v-btn> -->
      </v-toolbar-items>
    </v-toolbar>

    <div ref="pageContainer" id="pageContainer" class="Viewer">
      <div id="viewer" class="pdfViewer"></div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";
import * as PDFJSViewer from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

import { saveBlob } from "@/helpers/saveFile";
import notification from "@/helpers/notification";
export default {
  name: "PdfViewer",
  props: {
    src: String,
    blob: Blob,
    fileName: String,
  },
  data() {
    return {
      eventBus: null,
      pdfViewer: null,
      container: null,
      pinchZoomEnabled: false,
    };
  },
  created() {
    this.initEventBus();
  },
  mounted() {
    this.getPdf();
  },
  methods: {
    async getPdf() {
      var src = this.src;
      if (this.blob) {
        src = URL.createObjectURL(this.blob);
      }
      this.container = this.$refs.pageContainer;
      this.pdfViewer = new PDFJSViewer.PDFViewer({
        container: this.container,
        eventBus: this.eventBus,
      });

      await pdfjsLib.getDocument(src).promise.then((pdf) => {
        this.pdfViewer.setDocument(pdf);
      });
    },

    initEventBus() {
      let eventBus = new PDFJSViewer.EventBus();
      eventBus.on("pagesinit", (e) => {
        if (e.source._currentPageNumber > 0) {
          var pagesWidth = e.source._pages[0].width;
          const scaleToscreen = this.container.offsetWidth / pagesWidth;

          this.pdfViewer.currentScaleValue =
            scaleToscreen > 1 ? 1 : scaleToscreen;
        }
        this.$emit("pdfOpened", true);

        // if (!this.pinchZoomEnabled) {
        //   this.pinchZoomEnabled = true;
        //   this.enablePinchZoom();
        // }
      });
      this.eventBus = eventBus;
    },
    enablePinchZoom() {
      let startX = 0,
        startY = 0;
      let initialPinchDistance = 0;
      let pinchScale = 1;
      const viewer = document.getElementById("viewer");
      const container = document.getElementById("viewerContainer");
      const reset = () => {
        startX = startY = initialPinchDistance = 0;
        pinchScale = 1;
      };

      // Prevent native iOS page zoom
      //document.addEventListener("touchmove", (e) => { if (e.scale !== 1) { e.preventDefault(); } }, { passive: false });
      document.addEventListener("touchstart", (e) => {
        if (e.touches.length > 1) {
          startX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
          startY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
          initialPinchDistance = Math.hypot(
            e.touches[1].pageX - e.touches[0].pageX,
            e.touches[1].pageY - e.touches[0].pageY
          );
          notification.success(`touchstart ${initialPinchDistance}`);
        } else {
          initialPinchDistance = 0;
        }
      });

      document.addEventListener(
        "touchmove",
        (e) => {
          // notification.success("touchmove");
          if (initialPinchDistance <= 0 || e.touches.length < 2) {
            return;
          }
          // if (e.scale !== 1) {
          //   e.preventDefault();
          // }
          const pinchDistance = Math.hypot(
            e.touches[1].pageX - e.touches[0].pageX,
            e.touches[1].pageY - e.touches[0].pageY
          );

          notification.success(`touchmove pinchDistance ${pinchDistance}`);
          const originX = startX + container.scrollLeft;
          const originY = startY + container.scrollTop;
          pinchScale = pinchDistance / initialPinchDistance;

          notification.success(`touchmove ${pinchScale}`);
          // viewer.style.transform = scale(${pinchScale});
          // viewer.style.transformOrigin = ${originX}px ${originY}px;
        },
        { passive: false }
      );

      document.addEventListener("touchend", (e) => {
        notification.success("touchend");
        if (initialPinchDistance <= 0) {
          return;
        }
        // viewer.style.transform = none;
        // viewer.style.transformOrigin = unset;
        // PDFViewerApplication.pdfViewer.currentScale *= pinchScale;
        this.pdfViewer.currentScale *= pinchScale;
        const rect = container.getBoundingClientRect();
        const dx = startX - rect.left;
        const dy = startY - rect.top;
        container.scrollLeft += dx * (pinchScale - 1);
        container.scrollTop += dy * (pinchScale - 1);
        reset();
      });
    },
    zoomIn() {
      const currentScaleValue = this.pdfViewer.currentScale * 100;
      const newValue = this.removeDesimals(currentScaleValue + 10) / 100;
      this.pdfViewer.currentScaleValue = newValue;
    },
    zoomOut() {
      const currentScaleValue = this.pdfViewer.currentScale * 100;
      const newValue = this.removeDesimals(currentScaleValue - 10) / 100;
      this.pdfViewer.currentScaleValue = newValue;
    },
    removeDesimals(value) {
      return ~~value;
    },
    save() {
      saveBlob(this.blob, this.fileName);
    },
  },
  computed: {
    currentScaleDisplay() {
      return this.pdfViewer
        ? this.removeDesimals(this.pdfViewer.currentScale * 100) + "%"
        : "";
    },
  },
};
</script>

<style lang="scss">
.Viewer {
  background-color: #444;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0px;
  padding-bottom: 10px;
  overflow-x: auto;
}
.pdfViewer {
  .page {
    margin: 0px auto 10px auto !important;
    border: none;
  }
}

.stickyHeader {
  position: sticky !important;
  top: 0px;
  z-index: 2;
}
</style>
